var _style, _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileyAngryGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "smiley_angry_gray_svg__Plus",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".smiley_angry_gray_svg__st0{fill:#666}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0m0 22.7c-2.9 0-5.6-1.2-7.5-3.1-.8-.8-1.5-1.7-2-2.6-.8-1.5-1.2-3.2-1.2-5C1.3 6.1 6.1 1.3 12 1.3c2.8 0 5.4 1.1 7.3 2.8 1 .9 1.8 2 2.4 3.2.7 1.4 1 3 1 4.6 0 6-4.8 10.8-10.7 10.8",
  className: "smiley_angry_gray_svg__st0"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 9.3,
  r: 1.3,
  className: "smiley_angry_gray_svg__st0"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 9.3,
  r: 1.3,
  className: "smiley_angry_gray_svg__st0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4 16.4c.1.2.2.4.3.5l1.2-.5c-.1-.2-.2-.4-.3-.7-1.4-2.4-4.1-3.9-6.9-3.8s-5.3 1.9-6.4 4.5l1.1.6c.9-2.1 3-3.6 5.3-3.7s4.5 1.1 5.7 3.1M7.762 5.981l.762-1.054 2.107 1.524-.762 1.053zM13.36 6.393l2.108-1.523.761 1.054-2.107 1.523z",
  className: "smiley_angry_gray_svg__st0"
})));
export { SvgSmileyAngryGray as ReactComponent };
export default __webpack_public_path__ + "smiley_angry_gray.svg";